import React from "react";

export const resourcesProvider = {
    getParkIconOptions,
    getParkIconItem,
};

function importAll(r) {
    return r.keys().map(r);
}

function getParkIconOptions(){
    try {
        let listItems

        try {
            listItems = importAll(require.context('../assets/images/icon/parks/svg/', false, /\.(png|jpe?g|svg)$/));
        } catch (e) {
            listItems = [];
        }

        return listItems.map((itemData) => {
            const id = itemData.replace("/static/media/", "").split('.')[0];
            return (
                {
                    id: id,
                    value: id,
                    label: <div><label>{id}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

function getParkIconItem(id){

    if (!id)
        return null;

    try {
        const listItems = importAll(require.context('../assets/images/icon/parks/svg/', false, /\.(png|jpe?g|svg)$/));

        const filteredItems = listItems.map((itemData) => {
            return itemData.replace("/static/media/", "").split('.')[0];
        });

        const item = filteredItems.find(i => i === id);

        return (
            {
                id: item,
                value: item,
                label: <div><label>{item}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}

export const moduleResourcesProvider = {
    getOptions : getModuleIconOptions,
    getItem : getModuleIconItem,
};

async function getModuleIconOptions(){
    try {
        let listItems

        try {
            listItems = importAll(require.context('../assets/images/icon/modules/', false, /\.(png|jpe?g|svg)$/));
        } catch (e) {
            listItems = [];
        }

        return listItems.map((itemData) => {
            const name = itemData.replace("/static/media/", "").split('.')[0];
            const ext = itemData.replace("/static/media/", "").split('.')[2];
            const fullName = name + '.' + ext;

            return (
                {
                    id: fullName ,
                    value: fullName,
                    label: <div><label>{fullName}</label></div>,
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

function getModuleIconItem(id){

    if (!id)
        return null;

    try {
        const listItems = importAll(require.context('../assets/images/icon/modules/', false, /\.(png|jpe?g|svg)$/));
        const mapedItems = listItems.map((itemData) => {
            const name = itemData.replace("/static/media/", "").split('.')[0];
            const ext = itemData.replace("/static/media/", "").split('.')[2];
            const fullName = name + '.' + ext;

            return (
                {
                    id: fullName ,
                    value: fullName,
                    label: <div><label>{fullName}</label></div>,
                }
            )
        });

        const item = mapedItems.find( mi => mi.id === id );

        return ( item );
    } catch (error) {
        console.log(error.message)
    }
}